<div class="flex flex-col w-52 h-9 items-center justify-center text-center text-cafe text-sm font-normal bg-white rounded-md shadow-[0px_1px_2px_0px_rgba(0,0,0,0.25)]">
  Producto eliminado del carrito
</div>
